import moment from 'moment-timezone'
import React, {useState, useEffect} from 'react'
import { Customer } from '../components/MakeReservation/MakeReservation'
import { paymentMethod } from '../components/MakeReservation/PaymentInfo'
import { IVehicleSearch } from '../interfaces/VehicleSearch'
import { User } from '../interfaces/User'
import {gaEvent} from "../services/GoogleAnalyticsEvents";
import {Check24rCookie, ICustomerBehaviourData} from "../services/CustomerBehaviourData";
import {FilterParameters, IAcrissCodes} from "../components/VehicleSearch/Filter";
import {handleUrlWithHashtag} from "../GetUrlParams";

const appContextAndRootURL = () => {
  // this function controls the API version, base assets path and app context for entire app
  const pageUrl = window.location.host;
  let APP_CONTEXT = 'staging';
  let ROOT_URL = '';
  let v3_API_URL = '';
  switch (pageUrl) {
    case "dev-rent.24rent.fi":
      APP_CONTEXT = "staging";
      v3_API_URL = process.env.REACT_APP_API_V3_STAGING_URL ?? '';
      return { APP_CONTEXT, ROOT_URL, v3_API_URL}
      break;
    case "rent.24rent.fi":
      APP_CONTEXT = "production";
      v3_API_URL = process.env.REACT_APP_API_V3_PROD_URL ?? '';
      return { APP_CONTEXT, ROOT_URL, v3_API_URL}
      break;
    case "dev-frontend.24rent.fi":
      APP_CONTEXT = "development";
      ROOT_URL = "/wp-content/plugins/24rent-reservation-machine/build";
      v3_API_URL = process.env.REACT_APP_API_V3_STAGING_URL ?? '';
      return { APP_CONTEXT, ROOT_URL, v3_API_URL}
      break;
    case "www.24rent.fi":
      APP_CONTEXT = "production";
      ROOT_URL = "/wp-content/plugins/24rent-reservation-machine/build";
      v3_API_URL = process.env.REACT_APP_API_V3_PROD_URL ?? '';
      return { APP_CONTEXT, ROOT_URL, v3_API_URL}
      break;

    default:
      console.log("Running localhost --> all default params")
      v3_API_URL = process.env.REACT_APP_API_V3_STAGING_URL ?? '';
      return { APP_CONTEXT, ROOT_URL, v3_API_URL} // localhost
      break;
  }
}

const {APP_CONTEXT, ROOT_URL, v3_API_URL} = appContextAndRootURL();

const getLocalObject = (storedKey: string) => {
  const p = sessionStorage.getItem(storedKey);
  // UGH: someone decided it was a good idea to write a string 'undefined' to this session variable
  if (p && p !== 'undefined') {
    return JSON.parse(p)
  }
  return undefined;
}

const checkDeviceType = () => {
  // check if desktop or mobile device: 2 checks
  // if mobile, BE will limit number of results returned to FE
  let check = false;
  (function (a) {
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od|ad)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) {
      check = true;
    }
  }(navigator.userAgent || navigator.vendor || (window as any).opera));

  if (window.innerWidth < 768 || window.screen.width < 768) { // min desktop width = 768
    check = true;
  }
  return check;
}

export interface IMarker {
  vehicleId: number;
  marker: google.maps.marker.AdvancedMarkerElement;
}

export interface ISearchParameters {
  location: google.maps.places.PlaceResult | any | null,
  pickupCity?: string;
  returnCity?: string;
  startDate: moment.Moment | null,
  startTime: string,
  endDate: moment.Moment | null,
  endTime: string,
  lat: number,
  lon: number,
  distance?: number,
  km?: number,
  vehicleType?: string,
  minTrunkVolume?: number,
  fuelType?: string,
  crossBorderArea?: string,
  transmission?: string,
  features?: string,
  sort?: string,
  showStart?: number,
  showAmount?: number,
  carId?: number,
  discount?: string,
  other?: string,
  utm_campaign?: string,
  utm_source?: string,
  utm_term?: string,
  utm_medium?: string,
  utm_content?: string,
  gclid?: string,
  cid?: string,
  cookie?: string | null,
  mobileDevice?: boolean,
  userPlaceSearch?: string;
}

const serviceDefault = {
  kmRange: 100,
  insurance: '1030,',
  export: false,
  exportDestination: '' as any,
  paymentMethod: paymentMethod.PAYTRAIL,
  handTruck: true,
  unlimitedKilometers: '',
  additionalDriver: false,
  addDriverNumber: '',
  addDriverName: '',
  hook: false,
  windshield: false,
  tireInsurance: false,
  cancellationInsurance: false,
  costPool: '',
  co2compensation: ''
  // one-way service indicated used directly from state below
}

const isDiscountCodeVip = (discountCode: string | undefined) => {
  // do not send url vip code in res create object if non-vip vehicle selected
  const search = handleUrlWithHashtag();
  let urlVipCode = new URLSearchParams(search).get("vip") ?? undefined;
  if (!urlVipCode) return discountCode;

  if (urlVipCode === discountCode) {
    return undefined;
  }

  return discountCode;
}

export interface IData {
  rootUrl?: string,
  appContext?: string,
  v3ApiUrl?: string;
  mapMarkers: IMarker[],
  filteredParams: FilterParameters,
  filteredVehicles?: IVehicleSearch[],
  noUnderTwentyOne: boolean,
  mapEnabled?: boolean,
  customer?: Customer,
  searchParameters?: ISearchParameters,
  user?: User,
  vehicle?: IVehicleSearch,
  mapData?: IVehicleSearch[],
  services?: any,
  reservation?: any,
  language?: string,
  route?: string,
  page?: number,
  twentyModal?: boolean,
  outOfRange?: boolean,
  stars?: [],
  mobileDevice?: boolean,
  reservationCreated?: any,
  acrissCodeFromUrl?: string,
  modelId?: number,
  mapCanInit?: boolean;
  authHashLogin?: boolean;
  acrissCodeSet?: IAcrissCodes | undefined;
  showOneWayReturnLocation?: number | undefined;
  changeSearchParameters: Function,
  changeUser: Function,
  changeVehicle: Function,
  changeMapData: Function,
  changeShowDefaultResults: Function,
  showDefaultResults?: boolean,
  changeMapEnable: Function,
  changeCustomer: Function,
  changeServices: Function,
  changeFilteredList: Function,
  changeFilterParams: Function,
  changeLoggedIn: Function,
  changeRoute: Function,
  changePage: Function,
  changeLanguage: Function,
  getReservationDays: Function,
  clearSelections: Function,
  oneWayRoutes?: any,
  oneWayRes?: boolean,
  changeResType: Function,
  changeOneWayRoutes: Function,
  enableOneWay?: boolean,
  changeEnableOneWay: Function,
  searchFiltersSelected?: boolean,
  changeSearchFiltersSelected: Function,
  sendGaEvent: Function,
  changeTwentyModal: Function,
  loggedIn?: boolean,
  validatedVipVehicles?: string,
  changeMapMarkers: Function,
  changeValidatedVipVehicles: Function,
  changeCustomerBehaviourData: Function,
  gtagTracking?: boolean,
  changeStars: Function,
  changeReservationCreated: Function;
  changeAcrissCodeFromUrl: Function,
  changeModelId: Function,
  changeMapCanInit: Function,
  changeAcrissCodeSet: Function,
  changeShowOneWayReturnLocation: Function,
}

const defaultState = {
  changeMapMarkers: () => null,
  changeNoUnderTwentyOne: () => null,
  changeMapEnable: () => null,
  changeSearchParameters: () => null,
  changeUser: () => null,
  changeVehicle: () => null,
  changeMapData: () => null,
  changeFilteredList: () => null,
  changeFilterParams: () => null,
  changeShowDefaultResults: () => null,
  changeCustomer: () => null,
  changeServices: () => null,
  changeRoute: () => null,
  changeLoggedIn: () => null,
  changeLanguage: () => null,
  clearSelections: () => null,
  getReservationDays: () => null,
  changeResType: () => null,
  changeOneWayRoutes: () => null,
  changeEnableOneWay: () => null,
  changeSearchFiltersSelected: () => null,
  sendGaEvent: () => null,
  changeTwentyModal: () => null,
  changeValidatedVipVehicles: () => null,
  changeCustomerBehaviourData: () => null,
  changeStars: () => null,
  changeAcrissCodeSet: () => null,
  changeShowOneWayReturnLocation: () => null,
}

type Props = {
  children?: React.ReactNode
}

export const DataContext = React.createContext<IData>(defaultState as unknown as IData)

const DataProvider = ({ children }: Props) => {
  const rootUrl = ROOT_URL;
  const appContext = APP_CONTEXT;
  const v3ApiUrl = v3_API_URL;
  const [route, setRoute] = useState<string>("/");
  const [user, setUser] = useState<User | undefined>(getLocalObject("user"));
  const [vehicle, setVehicle] = useState<IVehicleSearch | undefined>(getLocalObject("selectedCar"));
  const [mapData, setMapData] = useState<IVehicleSearch[] | undefined>(getLocalObject("allCars"));
  const [showDefaultResults, setShowDefaultResults] = useState(true);
  const [searchParameters, setSearchParameters] = useState<ISearchParameters | undefined>(getLocalObject("searchParameters"));
  const [oneWayRoutes, setOneWayRoutes] = useState([]);
  const [enableOneWay, setEnableOneWay] = useState<boolean>(false); // can use this set state when url or WordPress parameters are provided to app
  const [oneWayRes, setOneWayRes] = useState<boolean>(getLocalObject("oneway") ? getLocalObject("oneway") : false);
  const [searchFiltersSelected, setSearchFiltersSelected] = useState(false);
  const [mapEnabled, setMapEnabled] = useState<boolean>(true);
  const [gtagTracking, setGtagTracking] = useState<boolean>(false);
  const [page, setPage] = useState<number>(getLocalObject("page") ?? 0);
  const [validatedVipVehicles, setValidatedVipVehicles] = useState<string>(getLocalObject("vipVehicles") ?? '');
  const [noUnderTwentyOne, setNoUnderTwentyOne] = useState<boolean>(false);
  const [loggedIn, setLoggedIn] = useState(false);
  const [authHashLogin, setAuthHashLogin] = useState(false); // only auth hash login will not see customer info page
  const [filteredVehicles, setFilteredVehicles] = useState<IVehicleSearch[] | undefined>([]);
  const [filteredParams, setFilterParams] = useState<FilterParameters>({});
  const [mapMarkers, setMapMarkers] = useState<IMarker[]>([{} as IMarker]);
  const [stars, setStars] = useState<[] | undefined>(undefined); // vehicle testimonials.json
  const [acrissCodeSet, setAcrissCodeSet] = useState<IAcrissCodes | undefined>(undefined);
  const mobileDevice: boolean = checkDeviceType(); // always start with true, true will work for mobile+desktop, false has disadvantages for mobile
  // services, what's stored, or default value
  const [services, setServices] = useState(getLocalObject("services") ? getLocalObject("services") : serviceDefault);
  const [twentyModal, setTwentyModal] = useState<boolean>(false);
  const [outOfRange, setOutOfRange] = useState(false);
  const [language, setLanguage] = useState('fi');
  const [customerBehaviourUrlData, setCustomerBehaviourUrlData] = useState<ICustomerBehaviourData | undefined>(undefined); // send when searches occur + create res
  const r24Cookie = Check24rCookie();
  const [reservationCreated, setReservationCreated] = useState((getLocalObject("reservationCreated") && getLocalObject("reservationCreated") !== "false") ?? false);
  const [acrissCodeFromUrl, setAcrissCodeFromUrl] = useState<undefined | string>(undefined);
  const [modelId, setModelId] = useState<number | undefined>();
  const [mapCanInit, setMapCanInit] = useState(mobileDevice ? false : true); // for mobile - this will only be true when they click on "show map" button, desktop is always true
  const [showOneWayReturnLocation, setShowOneWayReturnLocation] = useState< number | undefined >(undefined);
  const { version } = require('../../package.json');

  useEffect(() => {
    changeEnableOneWay();

    if (searchParameters) {
      if (searchParameters.location) {
        setShowDefaultResults(false);
      }
    }

    if ((window as any).gtag){
      // enable Google Analytics if gtag func exists
      // console.log('gtagTracking on');
      setGtagTracking(true);
    } else {
      setGtagTracking(false);
    }

    let savedCustomer = getLocalObject("customer") ?? undefined;
    if (savedCustomer) {
      // for reload on payment screen --> saved Customer must be set at start to ensure res data is correct
      setCustomer({...savedCustomer, loggedIn: !!(user?.id && user?.birthDate)});
    }
  }, []);

  useEffect(() => {
    // handles logged in state when tab is reload/refreshed on customer info page
    if(user?.id && user?.birthDate && !reservationCreated) {
      setLoggedIn(true);
    };
  });

  // customer will always be populated from changes in user, services, loggedIn
  const [customer, setCustomer] = useState<any>({
    company: false, // added for our checkbox
    companyName: user?.company?.name ?? '',
    companyVatNumber: user?.company?.vatNumber ?? '',
    companyReference: user?.company?.reference ?? '',
    familyName: user?.familyName ?? '',
    givenName: user?.givenName ?? '',
    unregisteredForeigner: false, //true if user.language === 'en'&& !user.birthDate and customer selects foreigner //&& customer.noSSN
    registeredForeigner: !!user?.birthDate?.length && !(!user?.noPersonalIdCode && user?.personalIdCodeRecorded),
    personalIdCode: user?.personal_id_code ?? '',
    address: user?.address ?? '',
    dateOfBirth: user?.birthDate ?? user?.birthday ?? '',
    noBirthday: true,
    municipality: user?.municipality ?? '',
    postalCode: user?.postalCode ?? '',
    country: user?.country ?? '',
    secret: false,
    prepaid: false,
    phoneNumber: user?.phoneNumber ? user?.phoneNumber.replace(/\s/g,'') : '',
    phoneNumber2: user?.phoneNumber ? user?.phoneNumber.replace(/\s/g,'') : '',
    email: user?.email ? user?.email.trim() : '',
    email2: user?.email ? user?.email.trim() : '',
    additionalDriver: services?.additionalDriver ?? false,
    gdpr: false,
    agree: false,
    agree2: false,
    fairAccept: false,
    emailConsent: '',
    //member
    mayUseQuota: !!user?.mayUseQuota,
    relativeBankTransferDueDate: user?.relativeBankTransferDueDate,
    mayUseBankTransferAnytime: user?.mayUseBankTransferAnytime,
    loggedIn: loggedIn,
    smsLogin: user?.smsLogin ?? false,
  });

  // reservation will always be populated from changes in user, services, vehicle etc
  const [reservation, setReservation] = useState<any>();

  const handleBusySearching = () => {
    let now = moment();
    let start = moment().hour(8).minute(0);
    let end = moment().hour(21).minute(0);
    if (now.isBetween(end, start) && !customer?.loggedIn) {
      setOutOfRange(true)
    } else {
      setOutOfRange(false)
    }
  }

  useEffect(() => {
    if (user?.saveToCustomer && services) {
      // console.log('XXX USER: ', user);
      const newCustomer = {
        ...customer,
        companyName: user?.company?.name ?? "",
        companyVatNumber: user?.company?.vatNumber ?? '',
        companyReference: user?.company?.reference ?? '',
        familyName: user?.familyName ?? '',
        givenName: user?.givenName ?? '',
        registeredForeigner: !!user?.birthDate?.length && !(!user?.noPersonalIdCode && user?.personalIdCodeRecorded),
        personalIdCode: user?.personal_id_code ?? '',
        address: user?.address ?? '',
        dateOfBirth: user?.birthDate ?? user?.birthday ?? '',
        municipality: user?.municipality ?? '',
        postalCode: user?.postalCode ?? '',
        country: user?.country ?? '',
        phoneNumber: user?.phoneNumber ?? '',
        phoneNumber2: user?.phoneNumber ?? '',
        email: user?.email ?? '',
        email2: user?.email ?? '',
        additionalDriver: services.additionalDriver,
        agree: user?.tos ?? false,
        //member
        mayUseQuota: user?.mayUseQuota,
        loggedIn: loggedIn
      }
      setCustomer(newCustomer);
      sessionStorage.setItem("customer", JSON.stringify(newCustomer));
      setUser({...user, saveToCustomer: false} ); // reset so customer ris not update on every input change
    } else {
      if (customer?.loggedIn !== loggedIn) {
        setCustomer({...customer, loggedIn: loggedIn});
        sessionStorage.setItem("customer", JSON.stringify({...customer, loggedIn: loggedIn}));
      }
    }
  }, [user, services, loggedIn]);


  useEffect(() => {
    if(route === '/makereservation'){
      const vehicleSession = getLocalObject("selectedCar") ? getLocalObject("selectedCar") : undefined;
      if(vehicleSession ) {
        const vehicleAgeCheck = vehicleSession;
        setNoUnderTwentyOne(vehicleAgeCheck.vehicleData?.noundertwentyone ?? false);
      }
    }
  }, [vehicle, route]);

  useEffect(() => {
    if(route === "/" && services !== serviceDefault && !vehicle) {
      // reset services selections if return to search page
      changeServices(serviceDefault);
    }
  }, [vehicle, route, services, serviceDefault])

  useEffect(() => {
    if (customer && searchParameters && services && vehicle && language) {
      let foreigner = customer?.unregisteredForeigner || customer?.registeredForeigner;
      let insuranceList = services.insurance;
      insuranceList += services.co2compensation ? ',' + services.co2compensation : '';
      insuranceList += services.windshield ? ',1026' : '';
      insuranceList += services.tireInsurance ? ',1038' : '';
      insuranceList += services.cancellationInsurance ? ',1040' : '';
      insuranceList += services.additionalDriver ? ',1041' : '';
      insuranceList += oneWayRes ? ',1050' : '';
      let reservationProps: any = {
        email: customer?.email ?? user?.phoneNumber,
        phoneNumber: customer?.phoneNumber ?? user?.phoneNumber,
        agree: !!customer?.agree,
        startDate: moment.isMoment(searchParameters?.startDate) ? searchParameters?.startDate!.clone().format("DD.MM.YYYY")
            : moment(searchParameters?.startDate).format("DD.MM.YYYY"), // if start date is 'null' in some odd case -->
        // it will send that to BE and throw and error rather than add today's date (this will be more of an issue if customer pays for incorrect start date)
        startTime: searchParameters?.startTime,
        endDate: moment.isMoment(searchParameters?.endDate) ? searchParameters?.endDate.clone().format("DD.MM.YYYY")
            : moment(searchParameters?.endDate).format("DD.MM.YYYY"),
        endTime: searchParameters?.endTime,
        km: services.kmRange,
        carId: vehicle?.id,
        insurance: insuranceList,
        export: services.export,
        exportDestination: services.exportDestination.value,
        other: services.hook === true ? 1027 : '',
        quick: 0,
        services: (!services.export && services.kmRange===0)? 'unlimitedKilometers' : '', // for api3
        retry: 0,
        costPool: "",
        discount: vehicle?.onsale?.extra ?
            (!vehicle?.privateData?.vip ?
                isDiscountCodeVip(searchParameters?.discount ?? '') : undefined)
            : (vehicle?.onsale ? undefined : !vehicle?.privateData?.vip ?
                isDiscountCodeVip(searchParameters?.discount ?? '') : undefined),
        ss: user?.smsLogin && user?.noPersonalIdCode !== undefined ? '' : (foreigner ? user?.birthday : customer?.personalIdCode),
        firstname: customer?.givenName ?? user?.givenName,
        lastname: customer?.familyName ?? user?.familyName,
        streetAddress: customer?.address,
        zip: customer?.postalCode,
        city: customer?.municipality,
        country: foreigner ? customer?.country : 'Finland',
        noSS:  user?.smsLogin && user?.noPersonalIdCode !== undefined ? user?.noPersonalIdCode : (foreigner), //can be a foreigner with customer?.foreigner===false when birthdate set on backend
        paymentMethod: services.paymentMethod ?? paymentMethod.PAYTRAIL,
        login: (user?.birthDate && user?.birthDate !== '') && customer?.loggedIn ? 1 : 0, //user is logged in already, let backend know not to look for ssn .
        //Even when customer enters ss, it will be updated on set customer api call not here.
        language,
        onsales: vehicle?.onsale?.extra ? 0 : vehicle?.onsale?.price,
        oneway: oneWayRes,
        additionalDriver: services.additionalDriver ?? false,
        emailConsent: customer?.emailConsent,
        cookie: r24Cookie,
        rrmVersion: version,
        rrmDomain: window.location.host
      };

      if(oneWayRes) {
        reservationProps.pickupCity = searchParameters?.pickupCity;
        reservationProps.returnCity = searchParameters?.returnCity;
      }

      if (services.additionalDriver) {
        reservationProps.driverNumber = services?.addDriverNumber;
        reservationProps.driverName = services?.addDriverName;
      }

      if (customer?.companyName) {
        reservationProps.companyName = customer?.companyName;
        reservationProps.companyVatNumber = customer?.companyVatNumber; //valid example: 5772118-3
        reservationProps.companyReference = customer?.companyReference;
      }

      if(customerBehaviourUrlData) {
        reservationProps.utm_campaign = customerBehaviourUrlData.utm_campaign ?? '';
        reservationProps.utm_source = customerBehaviourUrlData.utm_source ?? '';
        reservationProps.utm_term = customerBehaviourUrlData.utm_term ?? '';
        reservationProps.utm_medium = customerBehaviourUrlData.utm_medium ?? '';
        reservationProps.utm_content = customerBehaviourUrlData.utm_content ?? '';
        reservationProps.gclid = customerBehaviourUrlData.gclid ?? '';
        reservationProps.cid = user?.id ?? customerBehaviourUrlData.cid;
      }
      setReservation(reservationProps);
    }

  }, [customer, searchParameters, services, vehicle, language]);


  const changeSearchParameters = (searchParams: ISearchParameters) => {
    let searchParameters = searchParams ? {...searchParams, mobileDevice: mobileDevice} : searchParams;
    sessionStorage.setItem("searchParameters", JSON.stringify(searchParameters));
    setSearchParameters(searchParameters);
  }

  const changeFilteredList = (filteredVehicles: IVehicleSearch[] | undefined) => {
    if(filteredVehicles && filteredVehicles.length > 0){
      setFilteredVehicles(filteredVehicles);
    } else {
        setFilteredVehicles([]);
    }
  }

  const changeFilterParams = (filterParams: FilterParameters) => {
    setFilterParams(filterParams);
  }

  const changeMapMarkers = (mapMarkers: IMarker[]) => {
    setMapMarkers(mapMarkers);
  }

  const changeTwentyModal = (twentyModal: boolean) => {
    setTwentyModal(twentyModal);
  }

  const changeUser = (user: User) => {
    sessionStorage.setItem("user", JSON.stringify(user));
    setUser(user);
  }

  const changeMapEnable = (mapEnabled: boolean) => {
    setMapEnabled(mapEnabled);
    sessionStorage.setItem("mapEnabled", JSON.stringify(mapEnabled));
  }

  const changeMapData = (data: IVehicleSearch[]) => {
    if (data.length !== 0) {
      sessionStorage.setItem("allCars", JSON.stringify(data));
      setMapData(data);
    } else {
      setMapData([]);
      sessionStorage.removeItem("allCars");
    }
  }

  const changeShowDefaultResults = (defaultResults: boolean) => {
    setShowDefaultResults(defaultResults);
  }

  const changeVehicle = (vehicle: IVehicleSearch) => {
    sessionStorage.setItem("selectedCar", JSON.stringify(vehicle));
    setVehicle(vehicle);
  }

  const changeCustomer = (customer: Customer) => {
    sessionStorage.setItem("customer", JSON.stringify(customer));
    setCustomer(customer);
  }

  const changeServices = (services: any) => {
    sessionStorage.setItem("services", JSON.stringify(services));
    setServices(services);
  }

  const changeLoggedIn = (loggedIn: boolean, authHash?: string) => {
    if(authHash && authHash !== '' && loggedIn){
        setLoggedIn(true);
        setAuthHashLogin(true);
    } else {
      setLoggedIn(loggedIn);
    }
  }

  const changeRoute = (route: string) => {
    setRoute(route)
    sessionStorage.setItem("route", route)
  }

  const changeLanguage = (language: string) => {
    setLanguage(language);
  }

  const changePage = (page: number) => {
    const storedPage = sessionStorage.getItem('page');
    const newPage = page ? page : (storedPage ? JSON.parse(storedPage) : 0);
    sessionStorage.setItem("page", JSON.stringify(newPage));
    setPage(newPage);
  }

  const getReservationDays = () => {
    // Used to get multiplier to calculate prices
    // 24 hours = 1
    // 1 day 1 hours 0 mins = 2, and so on...
    if (!searchParameters) {
      return 0;
    }
    let startD = moment(searchParameters.startDate)
    let endD = moment(searchParameters.endDate);
    let minutesAfterFullDays = (endD.diff(startD, "minutes"))%(24*60);
    if (minutesAfterFullDays === 0) {
      return (endD.diff(startD, "days"));
    } else {
      return (endD.diff(startD, "days") + 1);
    }
  }

  const sendGaEvent = (category: any, action: any, label: any, value: any) => {
    // called function here to ensure updated 'gtagTracking' value is used, instead of initial state
    gaEvent(gtagTracking, category, action, label, value, appContext);
  };

  const clearSelections = () => {
    sessionStorage.removeItem("customer");
    sessionStorage.removeItem("user");
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("selectedCar");
    sessionStorage.removeItem("services");
    sessionStorage.removeItem("searchParameters");
    sessionStorage.removeItem("oneway");
    sessionStorage.removeItem("allCars");
    sessionStorage.removeItem("vipVehicles");
    sessionStorage.removeItem("coupon");
    sessionStorage.removeItem("urlCodeValid");
    setCustomer(undefined);
    setUser(undefined);
    setLoggedIn(false);
    setVehicle(undefined);
    setServices(serviceDefault);
    setSearchParameters(undefined);
    setMapData([]);
    setTwentyModal(false)
    setValidatedVipVehicles('');
    setReservationCreated(false);
  }

  const changeResType = (type: boolean) => {
    // changes between OneWay and a2a res options
    setOneWayRes(type);
    sessionStorage.setItem("oneway", JSON.stringify(type));
  }

  const changeOneWayRoutes = (routes: any) => {
    setOneWayRoutes(routes);
  }

  const changeEnableOneWay = () => {
    if(process.env.REACT_APP_ENABLE_ONE_WAY_FEATURE){
      setEnableOneWay(process.env.REACT_APP_ENABLE_ONE_WAY_FEATURE === 'true');
    } else setEnableOneWay(false); // if no initial env. variable found, disable one way feature
  }

  const changeSearchFiltersSelected = (filtersSelected: boolean) => {
    setSearchFiltersSelected(filtersSelected);
  }

  const changeValidatedVipVehicles = (vehicleId: number) => {
    if (vehicleId !== -1) {
      let vipVehiclesArr = validatedVipVehicles;
      vipVehiclesArr += "," + vehicleId.toString();
      sessionStorage.setItem('vipVehicles', JSON.stringify(vipVehiclesArr));
      setValidatedVipVehicles(vipVehiclesArr.toString());
    } else if (validatedVipVehicles.length) {
      // clear vip vehicles if new coupon applied
      sessionStorage.removeItem('vipVehicles');
      setValidatedVipVehicles('');
    }
  }

  const changeCustomerBehaviourData = (behaviourData: ICustomerBehaviourData) => {
    setCustomerBehaviourUrlData(behaviourData);
  }

  const changeStars = (starsData: any) => {
    if(typeof starsData === "object") {
      setStars(starsData);
    }
  }

  const changeReservationCreated = (resCreated: any) => {
    setReservationCreated(resCreated);
  }

  const changeAcrissCodeFromUrl = (acrissCode: string | undefined) => {
    let acrissCodeToString;
    if (acrissCode){
      switch(acrissCode) {
        case '1':
          acrissCodeToString = 'compact';
          break;
        case '2':
          acrissCodeToString = 'stw';
          break;
        case '3':
          acrissCodeToString = 'suv';
          break;
        case '4':
          acrissCodeToString = 'minibus';
          break;
        case '5':
          acrissCodeToString = 'van';
          break;
        default:
          return;
      }
    }

    if (acrissCodeToString) {
      setAcrissCodeFromUrl(acrissCodeToString);
    } else {
      setAcrissCodeFromUrl(undefined);
    }
  }

  const changeModelId = (modelIdNum: number | undefined) => {
    setModelId(modelIdNum);
  }

  const changeMapCanInit = () => {
    setMapCanInit(true);
  }

  const changeAcrissCodeSet = (acrissCodesData: IAcrissCodes | undefined) => {
    if (!acrissCodesData) {
      return;
    }

    if (acrissCodesData.stw) { // check one of the expected objects and if present, set all data
      setAcrissCodeSet(acrissCodesData);
    }
  }

  const changeShowOneWayReturnLocation = (oneWayVehicleData: number | undefined) => {
    if (!oneWayVehicleData && showOneWayReturnLocation) {
      setShowOneWayReturnLocation(undefined);
    } else {
      setShowOneWayReturnLocation(oneWayVehicleData);
    }
  }

  const state = {
    rootUrl,
    appContext,
    v3ApiUrl,
    noUnderTwentyOne,
    customer,
    mapMarkers,
    filteredParams,
    searchParameters,
    user,
    vehicle,
    route,
    language,
    mapData,
    services,
    reservation,
    mapEnabled,
    twentyModal,
    oneWayRoutes,
    oneWayRes,
    enableOneWay,
    searchFiltersSelected,
    outOfRange,
    page,
    loggedIn,
    validatedVipVehicles,
    gtagTracking,
    filteredVehicles,
    stars,
    mobileDevice,
    reservationCreated,
    acrissCodeFromUrl,
    modelId,
    mapCanInit,
    authHashLogin,
    acrissCodeSet,
    showOneWayReturnLocation,
    changeMapMarkers,
    changeFilterParams,
    changeFilteredList,
    handleBusySearching,
    changeNoUnderTwentyOne: setNoUnderTwentyOne,
    changeSearchParameters,
    changeUser,
    changeVehicle,
    changeMapData,
    changeShowDefaultResults,
    changeCustomer,
    changeServices,
    changeLoggedIn,
    changeRoute,
    changeLanguage,
    getReservationDays,
    clearSelections,
    changeTwentyModal,
    changeResType,
    changeOneWayRoutes,
    changeEnableOneWay,
    changeSearchFiltersSelected,
    changeMapEnable,
    sendGaEvent,
    showDefaultResults,
    changePage,
    changeValidatedVipVehicles,
    changeCustomerBehaviourData,
    changeStars,
    changeReservationCreated,
    changeAcrissCodeFromUrl,
    changeModelId,
    changeMapCanInit,
    changeAcrissCodeSet,
    changeShowOneWayReturnLocation
  }

  return <DataContext.Provider value={state}>{children}</DataContext.Provider>
}

export default DataProvider